import { Component, onWillRender, useState, useComponent, xml, status } from "@odoo/owl";
import { SelfOrderRouter } from "./router2";

/**
 * Paraméter parsing segédfüggvények
 */
function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function zip(array1, array2) {
    const result = [];
    const length = Math.min(array1.length, array2.length);
    for (let i = 0; i < length; i++) {
        result.push([array1[i], array2[i]]);
    }
    return result;
}

function parseParams(matches, paramSpecs) {
    return Object.fromEntries(
        zip(matches, paramSpecs).map(([match, paramSpec]) => {
            const { type, name } = paramSpec;
            switch (type) {
                case "int":
                    return [name, parseInt(match)];
                case "string":
                    return [name, match];
                default:
                    throw new Error(`Unknown type ${type}`);
            }
        })
    );
}

/**
 * Router service védett metódus wrapper
 */
function _protectMethod(component, fn) {
    return function (...args) {
        if (status(component) === "destroyed") {
            return Promise.reject(new Error("Component is destroyed"));
        }

        const prom = Promise.resolve(fn.call(this, ...args));
        const protectedProm = prom.then((result) =>
            status(component) === "destroyed" ? new Promise(() => {}) : result
        );
        return Object.assign(protectedProm, {
            abort: prom.abort,
            cancel: prom.cancel,
        });
    };
}

const routerRegistry = {};

/**
 * Router service használata komponensben
 */
export function useService(serviceName) {
    const component = useComponent();

    if (serviceName === "router") {
        if (serviceName in routerRegistry) {
            return routerRegistry[serviceName];
        }

        const service = new SelfOrderRouter();
        routerRegistry[serviceName] = service;
        return service;
    }

    throw new Error(`Service ${serviceName} is not available`);
}

/**
 * Router komponens - útvonal alapú nézetek kezelése
 */
export class Router extends Component {
    static props = { slots: Object };
    static template = xml`<t t-slot="{{activeSlot}}" t-props="slotProps"/>`;

    setup() {
        console.log('Router setup called');
        this.router = useState(useService("router"));
        this.activeSlot = "default";
        this.slotProps = {};
        this.routes = {};

        // Route-ok regisztrálása a slot-okból
        for (const [routeName, slot] of Object.entries(this.props.slots)) {
            const route = slot.route;
            const paramStrings = route.match(/\{\w+:\w+\}/g);

            if (!paramStrings) {
                this.routes[routeName] = {
                    route,
                    paramSpecs: [],
                    regex: new RegExp(`^${route}$`)
                };
                continue;
            }

            const paramSpecs = paramStrings.map((paramString) => {
                const [, type, name] = paramString.match(/(\w+):(\w+)/);
                return { type, name };
            });

            const regex = new RegExp(
                `^${route
                    .split(/\{\w+:\w+\}/)
                    .map((part) => escapeRegExp(part))
                    .join("([^/]+)")}$`
            );

            this.routes[routeName] = { route, paramSpecs, regex };
        }

        this.router.registerRoutes(this.routes);

        onWillRender(() => {
            this.matchURL();
        });
    }

    matchURL() {
        const path = this.router.path;

        for (const [routeName, { paramSpecs, regex }] of Object.entries(this.routes)) {
            const match = path.match(regex);
            if (match) {
                const parsedParams = parseParams(match.slice(1), paramSpecs);
                this.router.activeSlot = routeName;
                this.activeSlot = routeName;
                this.slotProps = parsedParams;
                return;
            }
        }

        this.router.activeSlot = "default";
        this.router.navigate("default");
    }
}
